module.exports = "<span ng-bind=\"$parent.row.name\" title=\"{{$parent.row.name}}\" am-tooltip=\"top center to bottom center\"></span>"